import { defineComponent as _defineComponent } from 'vue'
import { onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
import { onMounted, Ref, ref, onUnmounted, watch, nextTick } from "vue";
import {
  getRoomData,
  getMatchData,
  getMatchInfo,
  MatchCheckHost,
  getPlayMp4,
  MatchCheckHostOther,
  encryptionLiveInfo,
} from "@/api/php/player";
import { PlayerModel } from "@/model/playerModel";
import { Toast } from "vant";
import Platform from "@/config/platform";
import { storeToRefs } from "pinia";

import { usePiniaState } from "@/store/userPinia";
import { roomPiniaState } from "@/store/roomPinia";
import PlayChat from "@/components/player/PlayerChat.vue";
import MessageChat from "@/views/message/Chat.vue";
import Cover from "../../components/player/Cover.vue";
import Anchor from "@/components/player/Anchor.vue";
import AnchorTab from "@/components/player/AnchorTab.vue";
import Live from "@/components/player/Live.vue";
import TameBasketball from "@/components/player/TeamBasketball.vue";
import BasketBallFenxi from "@/components/player/BasketBallFenxi.vue";
import FootballFenxi from "@/components/player/FootballFenxi.vue";
import Zhishu from "@/components/player/Zhishu.vue";
import TeamFootball from "@/components/player/TeamFootball.vue";
import Football from "@/components/player/Football.vue";
import Basketball from "@/components/player/Basketball.vue";
import Clipboard from "clipboard";

// import onmsg from "@/assets/images/onmsg.gif";
// import sxlai from "@/assets/images/sxlai.png";
import back from "@/assets/images/room_back.png";
import football_bg from "@/assets/images/room_football_bg.png";
import basketball_bg from "@/assets/images/room_basketball_bg.png";
import { Match } from "@/model/Match";
import { getFreeIdIndex, fbqEvent, checkFirstEnterRoom } from "@/uitls/uitls";
import PlayerGroupChat from "@/views/player/PlayerGroupChat.vue";
import PlayerPrivateChat from "@/views/player/PlayerPrivateChat.vue";


import {
  msg_join_chatroom,
  msg_quit_chatroom,
  msg_get_user_info,
} from "@/network/socket/SocketReq";
import EventBus from "@/uitls/EventBus";
import { serverConfigPiniaState } from "@/store/serverConfig";
import { getChatLast, getIMListAll, getImUser } from "@/network/db/dbServe";
import { YMPush, formatDate } from "@/uitls/uitls";
import {
  cheackQuery,
  goHome,
  ToBack,
  nativeToLogin,
  toLocationBrowser,
  toMsgChat,
  toMsgList,
  toRemotePlay,
  toDownloadApp,
  checkSetNickname,
} from "@/uitls/native";
import { Storage } from "@/uitls/Storage";
import IMUtils from "@/network/socket/imUtils";
import { sendImMsg } from "@/api/im";
import Socket from "@/network/socket/socket";
import { useI18n } from "vue-i18n";
import { getCachedDomain } from '@/store/playerDomain';

// import visibility from "vue-visibility-change";
import { nativeToNewWeb } from "@/uitls/native";
import { imUserModel } from "@/model/chatModel";


export default /*#__PURE__*/_defineComponent({
  name: 'Player',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n();
const ConfigpiniaStore = serverConfigPiniaState();
const userStore = usePiniaState();
const roomStore = roomPiniaState();
const { toLogin, isLogin } = userStore;
const { isYk, user } = storeToRefs(userStore);
// const piniaStore = serverConfigPiniaState();
// const { web_pm_tips, web_fullscreen_tips, replay_download_tips } = storeToRefs(piniaStore);

const { changeIsjion, cleanMsgList, changeRoomPlayer } = roomStore;
const { getConfig, roomMsgShield } = ConfigpiniaStore;
const matchShare = require(`@/assets/${process.env.VUE_APP_NAME}/match_share.png`)
const down68 = require(`@/assets/${process.env.VUE_APP_NAME}/down68.png`)
const copyidimg = require(`@/assets/${process.env.VUE_APP_NAME}/copyid.png`)
const shareImg = require(`@/assets/${process.env.VUE_APP_NAME}/shareImg.png`)
// const posmsgtop = require(`@/assets/${process.env.VUE_APP_NAME}/posmsgtop.png`)
const gift = require(`@/assets/${process.env.VUE_APP_NAME}/gift_icon.png`)
const th = process.env.VUE_APP_Language as string;
const changeLine = require(`@/assets/${process.env.VUE_APP_NAME}/change_line.png`)
const touping = require(`@/assets/${process.env.VUE_APP_NAME}/toupin.png`)
const playhz = require(`@/assets/${process.env.VUE_APP_NAME}/play_hz.png`)
const plany_rb_bg = require(`@/assets/${process.env.VUE_APP_NAME}/plany_rb_bg.png`)
const play_ktx = require(`@/assets/${process.env.VUE_APP_NAME}/play_ktx.png`)
const play_bt = require(`@/assets/${process.env.VUE_APP_NAME}/play_bt.png`)
const app_name = process.env.VUE_APP_NAME;
const dingyue_icon = require("@/assets/images/weishoucan_icon.png");
const yidingyue = require("@/assets/images/shoucan_icon.png");

const active = ref('chatroom');


const {
  configNoticebarText,
  configNoticebarTextTo,
  configCopyid,
  offChat,
  playHbTime,
  playHbPrice,
  // playHbUrl,
  playHbWeclome,
  is_has_history,
  is_show_host,
  is_has_intelligence,
  openAd,
  is_show_up68_copy_share,
  is_lb,
  live_jump_time,
  live_jump_interval,
  live_jump_info,
  live_jump_url,
  live_jump_closable,
  live_load_img,
  web_pm_tips,
  web_fullscreen_tips,
  replay_download_tips,
  is_has_player_stats,
} = storeToRefs(ConfigpiniaStore);

const marqueeFontColor = process.env.VUE_APP_MARQUEE_FONT_COLOR as string;
const marqueeColor = process.env.VUE_APP_MARQUEE_COLOR as string;
const primaryColor = process.env.VUE_APP_PRIMARY_COLOR as string;
const router = useRouter();
const route = useRoute();
const roomdata: Ref<PlayerModel> = ref();
let ios = ref(/iPhone|iPad|iPod/i.test(navigator.userAgent))
//有主播吗，没主播的是清原，或者没源的
const isZb = ref(false);
//没源的，去显示封面
const isNoUrl = ref(false);
//有源的
const hasUrl = ref(false);
const coverData = ref();

//当前房间，主播在线吗？
const liveStatus = ref(true);
//数据回来了没
const hasData = ref(false);
const liveUrl = ref("");
const roomHeat = ref("");
const videoType = ref("");
const videoUrl = ref('');

//滚动条的文字
const noticebarText = ref("");
//点击滚动条文字，跳转url
const noticebarTextToUrl = ref("");

//1足球还是3篮球
const match_type = ref("");
// const is_game = ref(false);
//比赛id
const match_id = ref("");
//已经加入房间成功了吗？
const jionRoomSuccess = ref(false);
const roomTitle = ref('')

const room_key = ref('')
const anchor_id = ref('')
const liveType = ref('1');
const activityDatas = ref([]);
const match_data = ref(null);

const zb_chatkey = ref(null);
// const zb_tab_type = ref(1); // 1-显示主播信息 2-显示主播私聊
const assistanceAutoMsg = ref('');

const videoPoster = ref('');
const videoAd = ref('');
let postInteval = null;
//主播私聊红点状态
const privateChatRedDot = ref(false);
let playerTimer = null;
let autoAssistanceTimer: ReturnType<typeof setTimeout> | null = null;
const autoAssistanceDelay = 5000;
const autoAssistanceSentPrefix = "auto_assistance_sent";
const autoAssistanceCachePrefix = "auto_assistance_msg";
const autoAssistanceReadPrefix = "auto_assistance_read";
const standalone = Platform.standalone;


onMounted(async () => {
  await getConfig();
  cheackQuery(route);
  toLogin();
  roomMsgShield();
  checkRoomType();
  setTime();
  checkWebclip();
  YMPush("MAIN", "MoviePlayerPage");
  //timefn();
  tabsHeight();
  getLiveActivity();

  // 如果没弹出过红包，就弹出来
  checkStorageRb();

  // 检查时间
  checkLiveTime();

  window.addEventListener('message', onPostMessage, false);

  if (playerTimer) {
    clearInterval(playerTimer);
    playerTimer = null;
  }
  const playDomain = getCachedDomain();
  videoUrl.value = playDomain;
  document.body.style.overflow = 'hidden';

  let playerTabs = document.getElementById('playerTabs');
  if(playerTabs){
    let tabContentEle: any = playerTabs.getElementsByClassName("van-tabs__content");
    if (tabContentEle && tabContentEle.length > 0) {
      tabContentEle[0].style.height = (tabsHeight() - 70) + 'px';
    }
  }
  window.addEventListener('popstate', popstateBackRoute, { once: true });

});

EventBus.on("changePlayDomainNotication", () =>{
  const playDomain = getCachedDomain();
  videoUrl.value = playDomain;
});

const popstateBackRoute = () => {
  // 监听浏览器的返回事件
  // 阻止默认的返回行为
  history.pushState(null, null, window.location.origin);
  // 跳转到新页面
  backRouter();
}

const postMsgToPlayer = (data) => {
  var pyiframe = document.getElementById("playiframe") as HTMLIFrameElement;
  console.log('postMessage: start', !!pyiframe);
  if (pyiframe) pyiframe.contentWindow.postMessage(data, '*');
}

EventBus.on('bgurlData', (data) => {
  // let bgurlData = { "event": 'bgurlData', 'bgurlData': data };
  videoPoster.value = data + '';
})
EventBus.on('openAd', (data) => {
  if (!!data) {
    videoAd.value = JSON.stringify(data);
  }
})

watch(roomdata, (newVal, oldVal) => {
  if (!newVal) {
    return;
  }
  scheduleAutoAssistanceMessage(newVal);
  postInteval = setInterval(() => {
    if (isLogin) {
      room_key.value = newVal.groupId
      anchor_id.value = String(newVal.user_id);
      statisticsPost(18);// 统计打点
      clearInterval(postInteval);
    }
  }, 1000);

})

watch(liveUrl, (newVal, oldVal) => {
  // if(ios){
  if (newVal === '' || !liveStatus.value) {
    changeRoomPlayer(false);
    if (playerTimer) {
      clearInterval(playerTimer);
      playerTimer = null;
    }
    postMsgToPlayer({ "event": 'pause', 'pause': true });
    return;
  }
  changeRoomPlayer(true)
  EventBus.emit("replayMsg", { url: newVal, type: videoType.value, bgurlData: localStorage.getItem('bgurlData') });
  var data = {
    "event": 'replayMsg',
    'url': newVal,
    'type': videoType.value,
    'livetype': liveType.value,
    'bgurlData': localStorage.getItem('bgurlData'),
    'openAd': Object.assign({}, openAd.value),
    'canfullscreen': !web_fullscreen_tips.value,
  };

  console.log("liveUrl", data);
  if (playerTimer) {
    clearInterval(playerTimer);
    playerTimer = null;
  }
  
  try {
    postMsgToPlayer(data);
    playerTimer = setInterval(() => {
      console.log('post url to player again');
      postMsgToPlayer(data);
    }, 1500)

  } catch (error) {
    console.error('Failed to post message to player:', error);
    setTimeout(() => {
      postMsgToPlayer(data);
    }, 100);
  }
  console.log('postMessage: end');
})


//const listenPageVisible = visibility.change((evt, hidden) => {
//  if (!hidden) {
// window.location.reload();
//  }
//})

const onSixinClick = () => {
  active.value = 'sixin';
}

const onChatZhuboClick = () => {
  active.value = 'chatzhubo';
}

EventBus.on("JoinRoomFail", () => {
  // router.replace('/')
  ToBack(router);
  // goHome(router);
});

EventBus.on("configNoticebarText", () => {
  const { url } = route.query;

  if (url == "1" || url == "2") {
    console.log("是清原，换跑马灯");
    // configNoticebarTextTo,configCopyid,
    copyid.value = configCopyid.value;
    noticebarText.value = configNoticebarText.value;
    noticebarTextToUrl.value = configNoticebarTextTo.value;
  }
});
const onclickSharel = () => {
  getUrl();
  alertMatchShare.value = true;
};

let liveToDownloadInterval = null;
let liveRoomTime = 0;
let hasShowLiveToDownload = false;
const liveTimeDownload = ref(false);
// 检查观看时间，是否需要弹出下载
const checkLiveTime = () => {
  if (Platform.client != "h5") {
    return;
  }

  // alert("live_jump_time:" + live_jump_time.value);
  if (live_jump_time.value > 0) {
    let localTime = Storage.get("liveRoomTime");
    if (!localTime) {
      localTime = 0;
    } else {
      localTime = Number(localTime);
    }
    liveToDownloadInterval = setInterval(checkLiveTick, 1000);

    liveRoomTime = localTime;
  }
};

const checkLiveTick = () => {
  if (liveTimeDownload.value) {
    return;
  }
  liveRoomTime++;
  Storage.set("liveRoomTime", liveRoomTime);
  // console.log('liveRoomTime', liveRoomTime);

  if (liveRoomTime - live_jump_time.value >= 0) {
    if (!hasShowLiveToDownload) {
      hasShowLiveToDownload = true;
      liveTimeDownload.value = true;
      if (live_jump_closable.value == 2) {
        postMsgToPlayer({ "event": 'pause', 'pause': true });
      }
    } else if (live_jump_interval.value > 0 && !liveTimeDownload.value) {
      let time = liveRoomTime - live_jump_time.value;
      if (time % live_jump_interval.value == 0) {
        liveTimeDownload.value = true;
        if (live_jump_closable.value == 2) {
          postMsgToPlayer({ "event": 'pause', 'pause': true });
        }
      }
    }
  }
}

// const replay_download_tips
let replayDownloadTime = true;
const checkReplayDownload = () => {
  if (liveType.value == '4' && replay_download_tips.value > 0) {
    const showDownDialog = () => {
      console.log('showDownDialog, pause play');
      liveTimeDownload.value = true
      postMsgToPlayer({ "event": 'pause', 'pause': true })
    }

    if (replayDownloadTime) {
      setTimeout(() => {
         showDownDialog()
        replayDownloadTime = false;
      }, replay_download_tips.value * 1000);
      
    } else {
      showDownDialog()
    }
  }
}

const liveTimeDonwApp = () => {
  // YMPush("DOWNLOAD", "点击下载");
  toLocationBrowser(live_jump_url.value);
  statisticsPost(1);
};

const closeLiveTimeDownApp = () => {
  liveTimeDownload.value = false;
  statisticsPost(1);
}

const closeAlertDown = () => {
  alertDown.value = false;
  statisticsPost(1);
}

const checkStorageRb = () => {
  console.log('checkStorageRb');

  if (th == 'th' || is_lb.value) {
    return;
  }
  let isShowRb = Storage.get("showRb");
  if (!isShowRb && playHbTime.value > 0) {
    console.log("playHbTime.value", playHbTime.value);
    setTimeout(() => {
      if (playHbTime.value > 3) {
        setTimeout(() => {
          alertRB.value = true;
        }, (playHbTime.value - 3) * 1000);
      } else {
        setTimeout(() => {
          alertRB.value = true;
        }, 1000);
      }
    }, 3000);
  }
};

const tochatzb = () => {
  // const id = roomdata.value.free_id;
  // let chatkey;
  // YMPush("CHAT", "私信主播");
  // statisticsPost(15);//用户私信主播 统计打点

  // showOnMsg.value = false;
  // redNum.value = 0;
  // chatkey = IMUtils.createChatKey(id).toString();
  // console.log('chatkey', chatkey);
  // toMsgChat(router, id, chatkey);

  YMPush("CHAT", "私信主播");
  statisticsPost(15);//用户私信主播 统计打点
  active.value = 'private_chat';
  
  // 清除主播私聊红点
  privateChatRedDot.value = false;
  markCurrentAutoAssistanceRead();
  
  // 延迟触发事件，确保 van-tabs 切换完成
  nextTick(() => {
    EventBus.emit('changeToPrivate', 0); // 0表示直接点击主播私聊标签
  });
};



const showDownApp = ref(false);
const checkWebclip = () => {
  showDownApp.value = !standalone && Platform.client == "h5";
};

const alertDown = ref(false);
const setTime = () => {
};

//如果页面路由改变了，强制刷新。重置所有数据。 主要场景是在tab里面直播，当前跳当前
onBeforeRouteUpdate((to) => {
  setTimeout(() => {
    location.reload();
  }, 500);
});

onUnmounted(() => {
  window.removeEventListener('popstate', popstateBackRoute)
  changeRoomPlayer(false)
  postMsgToPlayer({ "event": 'pause', 'pause': true });

  cleanMsgList()
  changeIsjion(false);
  //clearInterval(time.value);
  if (liveToDownloadInterval) {
    clearInterval(liveToDownloadInterval);
  }

  if (
    // isZb.value &&
    roomdata.value &&
    roomdata.value.groupId &&
    roomdata.value.groupId != "0"
  ) {
    msg_quit_chatroom(roomdata.value.groupId);
    console.log('quit chat room');

    // msg_quit_chatroom("102464");
  }
  //如果是主播不在线，通知首页刷新房间数据

  if (!liveStatus.value) {
    console.log("主播不在线刷新首页");

    EventBus.emit("refreshHomeLive");
  }

  EventBus.off("JoinRoom");
  EventBus.off("JoinRoomSuccess");
  EventBus.off("roomNewimlist");
  EventBus.off("JoinRoomFail");
  EventBus.off("showPalyNewMsgAnimation");
  EventBus.off("roomPlayAd");
  EventBus.off("configNoticebarText");
  EventBus.off("msg_join_chatroom_nty");
  EventBus.off("ChatRoomMsgItem");
  EventBus.off("changePlayDomainNotication");
  window.removeEventListener('message', onPostMessage, false);

  document.body.style.overflow = 'auto';
  if (playerTimer) {
    clearInterval(playerTimer);
    playerTimer = null;
  }
  if (postInteval) {
    clearInterval(postInteval);
    postInteval = null;
  }
  if (autoAssistanceTimer) {
    clearTimeout(autoAssistanceTimer);
    autoAssistanceTimer = null;
  }


  fbqEvent('trackCustom', 'ExitRoom', { time: liveRoomTime });

  // fbqEvent('trackCustom', 'Launch3Days');
});

EventBus.on("ChatRoomMsgItem", (msg: any) => {
  console.log(msg);

  const { result } = msg;
  if (result == 45) {
    if (standalone) {
      nativeToLogin(router);
    } else {
      alertDown.value = true;
    }
    return;
  }
});
const onPostMessage = (e) => {
  console.log('on post message:', e);

  switch (e.data.event) {
    case 'clickOpenAd':
      if (e.data.url && e.data.url != '') {
        toImg(e.data.url);
      }
      break;
    case 'requestFullscreen':
      statisticsPost(22);
      if (liveType.value == '4' || web_fullscreen_tips.value) {
        const { webclip } = route.query;
        if (!webclip && Platform.client == "h5") {
          liveTimeDownload.value = true;
        }
      }
      break;
    case 'receiveUrl':
      // 播放器收到消息
      if (playerTimer) {
        clearInterval(playerTimer);
        playerTimer = null;
      }
      break;
    case 'error':
      let errStr = e.data.error;
      console.log(errStr);

      if (errStr) {
        try {
          let err = JSON.parse(errStr);
          let currentSrc = err.currentSrc;
          if (currentSrc && currentSrc.indexOf('mixed.m3u8') != -1) {
            return;
          }

          if (err.errorCode) {
            Toast.success(`${err.networkState}, Code: ${err.errorCode}`);
          }
        } catch (error) {
        }
      }

      break;
    case 'onplay':
      // alert('play');
      checkReplayDownload();
      break;
    default:
      break;
  }
}

EventBus.on("roomNewimlist", () => {
  console.log("直播间收到，有消息来了");
  getMsgList();
});

EventBus.on("showPalyNewMsgAnimation", (user: any) => {
  // console.log("直播间动画", val);
  if (!user.isGroup && user.red !== 0) {
    if (active.value === 'private_chat') {
      privateChatRedDot.value = false;
      showOnMsg.value = false;
      EventBus.emit("imchat", user.chatkey);
      return;
    }
    newMsgUser.value = {
      name: user.nickname,
      url: user.headurl,
      uid: user.uid,
    };
    // 任何私信都设置红点
    privateChatRedDot.value = true;
    console.log('收到私信，设置红点');
    
    if (showNewMsgAnimation.value) {
      // showNewMsgAnimation.value = false;
      // //800hs后执行出来的动画
      // setTimeout(() => {
      //   showNewMsgAnimation.value = true;
      //   //3s后关闭
      //   setTimeout(() => {
      //     showNewMsgAnimation.value = false;
      //   }, 3000)
      // }, 800)
    } else {
      showNewMsgAnimation.value = true;
      //3s后关闭
      setTimeout(() => {
        showNewMsgAnimation.value = false;
      }, 7000);
    }
  }
});

//多少条消息
const redNum = ref(0);
//有人发消息来了
const showOnMsg = ref(false);
const getMsgList = async () => {
  const v = await getIMListAll();

  redNum.value = 0;
  showOnMsg.value = false;
  const isPrivateChatActive = active.value === 'private_chat';
  privateChatRedDot.value = false;

  for (let i = 0; i < v.length; i++) {
    const element = v[i] as any;
    const isRoomPrivateUser = element.uid == roomdata.value.free_id || (roomdata.value.free_id_list && roomdata.value.free_id_list.indexOf(element.uid) >= 0);
    if (element.red !== 0 && !element.isGroup && isRoomPrivateUser) {
      showOnMsg.value = true;
      redNum.value = element.red + redNum.value;
      if (!isPrivateChatActive) {
        privateChatRedDot.value = true;
      }
    }
  }

  // showNewMsgAnimation
};

const getCurrentUid = () => {
  const uid = user.value && user.value.uid ? user.value.uid : Storage.get("uid");
  if (!uid || uid == 0 || uid == "0") {
    return "";
  }
  return uid.toString();
};

const getAutoAssistanceRoomKey = (data) => {
  if (!data) {
    return "";
  }
  return (data.room_id || data.roomId || route.query.id || data.groupId || data.id || "").toString();
};

const parseAutoAssistanceMessages = (raw, fieldName: string) => {
  if (typeof raw === "string") {
    try {
      raw = JSON.parse(raw);
    } catch (e) {
      console.log(`${fieldName} parse fail`, raw);
      return [];
    }
  }
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw.filter((item) => item && item.content !== undefined && item.content !== null);
};

const getAutoAssistanceMessages = (data) => {
  const setData = data && data.set_data ? data.set_data : {};
  const assistanceMessages = parseAutoAssistanceMessages(
    setData.automatically_send_data_assistance,
    "automatically_send_data_assistance"
  );
  if (assistanceMessages.length > 0) {
    return assistanceMessages;
  }
  return parseAutoAssistanceMessages(setData.automatically_send_data, "automatically_send_data");
};

const getAutoAssistanceSentKey = (uid: string, roomKey: string) => {
  return `${autoAssistanceSentPrefix}:${uid}:${roomKey}:${formatDate(Date.now())}`;
};

const getAutoAssistanceCacheKey = (uid: string, roomKey: string) => {
  return `${autoAssistanceCachePrefix}:${uid}:${roomKey}:${formatDate(Date.now())}`;
};

const getAutoAssistanceReadKey = (uid: string, roomKey: string) => {
  return `${autoAssistanceReadPrefix}:${uid}:${roomKey}:${formatDate(Date.now())}`;
};

const hasAutoAssistanceSent = (key: string) => {
  try {
    if (localStorage.getItem(key) === "1") {
      return true;
    }
  } catch (e) {
    console.log("auto assistance localStorage get fail", e);
  }
  return !!Storage.get(key);
};

const hasAutoAssistanceRead = (uid: string, roomKey: string) => {
  try {
    return localStorage.getItem(getAutoAssistanceReadKey(uid, roomKey)) === "1";
  } catch (e) {
    console.log("auto assistance localStorage read get fail", e);
  }
  return false;
};

const markAutoAssistanceRead = (uid: string, roomKey: string) => {
  try {
    localStorage.setItem(getAutoAssistanceReadKey(uid, roomKey), "1");
  } catch (e) {
    console.log("auto assistance localStorage read set fail", e);
  }
};

const markCurrentAutoAssistanceRead = () => {
  const uid = getCurrentUid();
  const roomKey = getAutoAssistanceRoomKey(roomdata.value);
  if (!uid || !roomKey) {
    return;
  }
  markAutoAssistanceRead(uid, roomKey);
};

const markAutoAssistanceSent = (key: string) => {
  try {
    localStorage.setItem(key, "1");
  } catch (e) {
    console.log("auto assistance localStorage set fail", e);
  }
};

const getAutoAssistanceCache = (key: string) => {
  try {
    return localStorage.getItem(key) || "";
  } catch (e) {
    console.log("auto assistance localStorage cache get fail", e);
  }
  return "";
};

const setAutoAssistanceCache = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    console.log("auto assistance localStorage cache set fail", e);
  }
};

const restoreAutoAssistanceMessages = (uid: string, roomKey: string) => {
  const cache = getAutoAssistanceCache(getAutoAssistanceCacheKey(uid, roomKey));
  if (!cache) {
    return false;
  }
  assistanceAutoMsg.value = cache;
  if (active.value !== "private_chat" && !hasAutoAssistanceRead(uid, roomKey)) {
    privateChatRedDot.value = true;
  }
  return true;
};

const normalizeAutoAssistanceContent = (msgtype: number, content: any) => {
  if (msgtype == 4 && typeof content === "string") {
    try {
      const imageContent = JSON.parse(content);
      if (imageContent && imageContent.url) {
        return JSON.stringify(imageContent);
      }
    } catch (e) {
      //
    }
    return JSON.stringify({ url: content });
  }
  if (typeof content === "string") {
    return content;
  }
  return JSON.stringify(content);
};

const scheduleAutoAssistanceMessage = async (data) => {
  if (autoAssistanceTimer) {
    clearTimeout(autoAssistanceTimer);
    autoAssistanceTimer = null;
  }

  const roomKey = getAutoAssistanceRoomKey(data);
  const messages = getAutoAssistanceMessages(data);
  if (!roomKey || !data.free_id || messages.length === 0) {
    return;
  }

  const uid = getCurrentUid();
  if (uid && hasAutoAssistanceSent(getAutoAssistanceSentKey(uid, roomKey)) && restoreAutoAssistanceMessages(uid, roomKey)) {
    return;
  }

  autoAssistanceTimer = setTimeout(() => {
    const currentRoomKey = getAutoAssistanceRoomKey(roomdata.value);
    if (currentRoomKey !== roomKey) {
      return;
    }
    showAutoAssistanceMessages(roomdata.value);
  }, autoAssistanceDelay);
};

const getAutoAssistanceChatMsgNo = (baseChatMsgNo: number, index: number, total: number) => {
  return Number((baseChatMsgNo + (index + 1) / (total + 1)).toFixed(6));
};

const showAutoAssistanceMessages = async (data, scheduledBaseChatMsgNo?: number) => {
  const uid = getCurrentUid();
  const roomKey = getAutoAssistanceRoomKey(data);
  const messages = getAutoAssistanceMessages(data);
  if (!uid || !roomKey || !data || !data.free_id || messages.length === 0) {
    return;
  }

  const sentKey = getAutoAssistanceSentKey(uid, roomKey);
  if (hasAutoAssistanceSent(sentKey) && restoreAutoAssistanceMessages(uid, roomKey)) {
    return;
  }

  const assistantUid = Number(data.free_id);
  const chatkey = IMUtils.createChatKey(assistantUid).toString();
  const assistantUser: imUserModel = await getImUser(assistantUid);
  let baseChatMsgNo = scheduledBaseChatMsgNo;
  if (baseChatMsgNo === undefined) {
    const lastChat = await getChatLast(chatkey);
    baseChatMsgNo = Math.max(Number(lastChat && lastChat.chatmsgno ? lastChat.chatmsgno : 0), 0);
  }
  const baseTime = Date.now();
  const shouldUnread = active.value !== "private_chat";
  const list = messages.map((item, i) => {
    const msgtype = Number(item.type) || 1;
    return {
      id: `${sentKey}:${i}`,
      chatkey,
      chatmsgno: getAutoAssistanceChatMsgNo(baseChatMsgNo, i, messages.length),
      uid: assistantUid,
      content: normalizeAutoAssistanceContent(msgtype, item.content),
      headurl: assistantUser && assistantUser.headurl ? assistantUser.headurl : data.portrait,
      nickname: assistantUser && assistantUser.nickname ? assistantUser.nickname : data.nickname,
      phonenum: "",
      time: baseTime + i,
      msgtype,
      clientkey: `${sentKey}:${i}`,
      read: !shouldUnread,
      send: true,
      upLoadProgress: 100,
    };
  });

  const autoMsg = JSON.stringify(list);
  assistanceAutoMsg.value = autoMsg;
  setAutoAssistanceCache(getAutoAssistanceCacheKey(uid, roomKey), autoMsg);
  markAutoAssistanceSent(sentKey);
  if (shouldUnread) {
    privateChatRedDot.value = true;
  } else {
    markAutoAssistanceRead(uid, roomKey);
  }
};

//h5login成功
EventBus.on("JoinRoom", (data) => {
  toJoinRoom();
});

const toJoinRoom = () => {
  console.log('toJoinRoom');

  //监听加入直播间成功 
  let isEvent = false;
  if (EventBus.all.has('JoinRoomSuccess')) {
    let es = EventBus.all.get('JoinRoomSuccess');
    if (es && es.length > 0) {
      isEvent = true;
    }
  }

  if (!isEvent) {
    EventBus.on("JoinRoomSuccess", (data) => {
      
      jionRoomSuccess.value = true;
      changeIsjion(true, parseInt(roomdata.value.groupId));

      checkFirstEnterRoom(); // 打点统计
    });
  }
  if (
    roomdata.value &&
    roomdata.value.groupId &&
    roomdata.value.groupId != "0" &&
    !jionRoomSuccess.value
  ) {

    if (Platform.isLoginIM && window.$Socket.ws) {
      msg_join_chatroom(roomdata.value.groupId);
    } else {
      setTimeout(toJoinRoom, 1000);
    }
  } else {
    // console.log(roomdata.value);
  }
};

//检测房间的类型
const checkRoomType = async () => {
  //房间有3个类型，一个是有房间id的（有主播的）,一个是没有的清源。还有就是mp4(比赛集锦)
  let { id, url, matchType, heat, mt, mi, from } = route.query;
  if (from == 'tg') {
    let res: any = await MatchCheckHostOther({
      match_type: matchType,
      match_id: id,
    })
    
    if (res && res.code == 200 && res.data && res.data != 0) {
      matchType = res.data.match_type
      id = res.data.id
      liveType.value = res.data.live_type;
    } else {
      liveType.value = String(route.query.liveType);
    }
  } else if (mt && mi) {
    checkMachthHost(mt, mi);
    liveType.value = String(route.query.liveType);
  } else {
    liveType.value = String(route.query.liveType);
  }




  if (liveType.value == "1") {
    // 有主播的呗
    getData(id as string);
    return;
  }

  if (liveType.value == '4') {
    getLiveInfo(matchType, id);
    return;
  }


  if (liveType.value == "2") {
    console.log('清源');
    //清原
    getUrlMatch(matchType, id);
    match_type.value = matchType as string;
    match_id.value = id as string;

    noticebarText.value = configNoticebarText.value;
    copyid.value = configCopyid.value;
    noticebarTextToUrl.value = configNoticebarTextTo.value;

    return;
  }
  if (matchType && id && !url) {
    //没源的
    checkNoType(matchType, id);
    return;
  }
  if (heat) {
    //比赛集锦
    matchIsMp4(heat);
    noticebarText.value = configNoticebarText.value;
  }
};

//没源的，检测
const checkNoType = async (matchType, matchId) => {
  
  //先查一下有没有房间号
  const val: any = await MatchCheckHost({
    match_type: matchType,
    match_id: matchId,
  });
  
  if (val.code == 200 && val.data && val.data != 0) {
    getData(val.data);
    return;
  }
  console.log(`room_id为0或查询失败, 返回首页`);
  backRouter();
  return;
};

const checkMachthHost = async (match_type, match_id) => {
  const res: any = await MatchCheckHost({
    match_type,
    match_id,
  });
  console.log("外部进入直播间=====>");
  if (res.code == 200 && res.data && res.data != 0) {
    getData(res.data);
  } else {
    window.scroll({ top: 0, left: 0, behavior: "auto" });
    // router.replace('/?mq=1')
    //清掉所有参数，回到域名根目录
    window.location.href = window.location.origin;
  }
};

const matchIsMp4 = async (id) => {
  const res: any = await getPlayMp4({ id });
  if (res && res.code == 200 && res.data) {
    const room_title = route.query.title;
    if (room_title) {
      roomTitle.value = room_title as string
    }
    liveUrl.value = res.data.live_url;
    dataLiveUrl.value = liveUrl.value;
    videoType.value = "video/mp4";
  }
  // roomHeat.value = heat;
};
//是清源吗
const qingyuan = ref(false);
//获取清原的数据
const getUrlMatch = async (matchType, matchId) => {
  // getMatchData
  const res: any = await getMatchInfo({ type_id: matchType, id: matchId });

  console.log('match info', res);

  if (res.code == 200 && res.data) {
    const data = res.data;
    roomTitle.value = data.room_title
    roomdata.value = data;


    match_data.value = data;

    try {
      match_data.value.away_scores = JSON.parse(data.away_scores);
      match_data.value.home_scores = JSON.parse(data.home_scores);
    } catch (error) { }

    if (roomdata.value.free_id) {
      zb_chatkey.value = IMUtils.createChatKey(roomdata.value.free_id).toString();
      console.log('zb_chatkey', zb_chatkey.value);
      // checkAutoMsgToZB();
    }

    roomHeat.value = data.heat;
    const { url } = route.query;
    let _liveurl: string = data.live_url;
    dataLiveUrl.value = _liveurl + data.live_url_data;
    qingyuan.value = true;
    hasUrl.value = data.live_url;
    if (_liveurl.startsWith("rtmp://")) {
      _liveurl = _liveurl.replace("rtmp://", "https://");
      _liveurl = _liveurl + ".m3u8";
    }
    liveUrl.value = _liveurl + data.live_url_data;
    videoType.value = "application/x-mpegURL";
    console.log("liveUrl", liveUrl.value);
    if (roomdata.value.set_data && roomdata.value.set_data.pmd_content) {
      noticebarText.value = roomdata.value.set_data.pmd_content;
      noticebarTextToUrl.value = roomdata.value.set_data.pmd_url;
    }

    toJoinRoom();

    liveUrlList.value = [];
    let urlList = data.live_url_list;
    for (let i = 0; i < urlList.length; i++) {
      let u = urlList[i];
      if (u.startsWith("rtmp://")) {
        u = u.replace("rtmp://", "https://");
        u = u + ".m3u8";
      }
      u = u + data.live_url_data;
      const linetext = t('me.xianlu')
      liveUrlList.value.push({ name: `${linetext}${i + 1}`, url: u });
    }
  }

  // console.log(liveUrl.value);
  //这里要注意，可能
};
const getMatch = async (matchType, matchId) => {
  // 没源的
  const res: any = await getMatchData({
    type_id: matchType,
    jump_event_id: matchId,
  });

  if (res.code == 200) {
    coverData.value = res.data;
    // console.log(coverData.value);
  }
  // 这里要注意，可能
};

const getData = async (id: string) => {
  const res: any = await getRoomData({ room_id: id });
  // user_id
  console.log("getRoomData", res);

  if (res.code == 200) {
    roomTitle.value = res.data.room_title
    roomdata.value = res.data as PlayerModel;
    if (roomdata.value.match_id) {
      const num: number = roomdata.value.match_id;
      match_id.value = num.toString();
    }
    if (roomdata.value.free_id_list && roomdata.value.free_id_list.length > 0) {
      let id = getFreeIdIndex();
      let idx = id % roomdata.value.free_id_list.length;
      let frid = roomdata.value.free_id_list[idx];
      roomdata.value.free_id = frid;
      zb_chatkey.value = IMUtils.createChatKey(frid).toString();
      msg_get_user_info(frid);
    } else {
      if (roomdata.value.free_id) {
        zb_chatkey.value = IMUtils.createChatKey(roomdata.value.free_id).toString();
      }
    }
    console.log("zb_chatkey", zb_chatkey.value);
    if (zb_chatkey.value && zb_chatkey.value != "") {
      // checkAutoMsgToZB();
    }

    match_type.value = roomdata.value.type_id;
    isZb.value = true; //有主播的
    hasUrl.value = true;
    liveStatus.value = roomdata.value.live_status == 1 ? true : false;
    hasData.value = true;
    roomHeat.value = roomdata.value.heat.toString();
    if (roomdata.value.set_data && roomdata.value.set_data.pmd_content) {
      noticebarText.value = roomdata.value.set_data.pmd_content;
      noticebarTextToUrl.value = roomdata.value.set_data.pmd_url;
    }
    if (roomdata.value && roomdata.value.copy_content) {
      copyid.value = roomdata.value.copy_content;
    }


    toJoinRoom();

    if (roomdata.value.live_url) {
      liveUrlList.value = [];
      let urlList = roomdata.value.live_url_list;
      for (let i = 0; i < urlList.length; i++) {
        let u = urlList[i];
        if (u.startsWith("rtmp://")) {
          u = u.replace("rtmp://", "https://");
          u = u + ".m3u8";
        }
        u = u + roomdata.value.live_url_data;
        const linetext = t('me.xianlu')
        liveUrlList.value.push({ name: `${linetext}${i + 1}`, url: u });
      }
      let url: string = roomdata.value.live_url;
      dataLiveUrl.value = url + roomdata.value.live_url_data;

      if (url.startsWith("rtmp://")) {
        url = url.replace("rtmp://", "https://");
        url = url + ".m3u8";
      }
      url = url + roomdata.value.live_url_data;
      liveUrl.value = url;
      videoType.value = "application/x-mpegURL";
    }
  } else {
    Toast.fail(res.msg);
  }
};

const getLiveInfo = async (type_id, live_id) => {
  const res: any = await encryptionLiveInfo({ type_id: type_id, live_id: live_id });
  console.log("getLiveInfo", res);
  if (res.code == 200) {
    const data = res.data;
    roomTitle.value = data.room_title
    roomdata.value = data;


    match_data.value = data;

    if (roomdata.value.free_id) {
      zb_chatkey.value = IMUtils.createChatKey(roomdata.value.free_id).toString();
      console.log('zb_chatkey', zb_chatkey.value);
      // checkAutoMsgToZB();
    }

    roomHeat.value = data.heat;
    let _liveurl: string = data.live_url;
    dataLiveUrl.value = _liveurl;
    qingyuan.value = true;
    hasUrl.value = data.live_url;
    liveUrl.value = _liveurl;
    videoType.value = "application/x-mpegURL";
    console.log("liveUrl", liveUrl.value);
    if (roomdata.value.set_data && roomdata.value.set_data.pmd_content) {
      noticebarText.value = roomdata.value.set_data.pmd_content;
      noticebarTextToUrl.value = roomdata.value.set_data.pmd_url;
    }

    toJoinRoom();

    liveUrlList.value = [];
    let urlList = data.live_url_list;
    if (!urlList) {
      urlList = [];
    }
    for (let i = 0; i < urlList.length; i++) {
      let u = urlList[i];
      if (u.startsWith("rtmp://")) {
        u = u.replace("rtmp://", "https://");
        u = u + ".m3u8";
      }
      const linetext = t('me.xianlu')
      liveUrlList.value.push({ name: `${linetext}${i + 1}`, url: u });
    }


    console.log("liveUrl", liveUrl);

  } else {
    Toast.fail(res.msg);
  }
}

const backRouter = () => {
  
  changeRoomPlayer(false)
  console.log('back router');
  postMsgToPlayer({ "event": 'pause', 'pause': true });
  if (Platform.client != "h5") {
    //如果是原生，把socket断掉
    Socket.ws.close();
    Socket.ws = null;
  }

  const { mt, mi, replace } = route.query;
  if (mt && mi) {
    window.scroll({ top: 0, left: 0, behavior: "auto" });
    // router.replace('/?mq=1')

    window.location.href = window.location.origin;
  } else if (replace) {
    window.scroll({ top: 0, left: 0, behavior: "auto" });
    router.replace("/");
  } else {
    // 获取上一页的URL
    const previousPageURL = document.referrer;
    console.log('previousPageURL', previousPageURL);

    if (previousPageURL) {
      // 获取当前网页的URL
      const currentURL = window.location.href;

      // 提取上一页和当前网页的根域名
      function extractRootDomain(url) {
        const domain = url.split('/')[2];
        return domain.startsWith('www.') ? domain.substring(4) : domain;
      }

      const previousRootDomain = extractRootDomain(previousPageURL);
      const currentRootDomain = extractRootDomain(currentURL);

      // 判断上一页的根域名是否与当前网页的根域名相同
      const sameRootDomain = previousRootDomain === currentRootDomain;
      if (sameRootDomain) {
        router.back();
        return;
      }
    } else if (history.state && history.state.back) {
      // router.back();
    }
    
    if (Platform.client != "h5") {
      ToBack(router);
    }else{
      //回首页
      router.push({
        path: "/",
      });
    }
  }
};

//打开68下载地址
const click68 = () => {
  YMPush("DOWNLOAD", "download68");
  toLocationBrowser(Platform.down68);
  statisticsPost(2);// 统计打点
  // window.location.href = Platform.down68;
};
//打开滚动条的url
const clickNoticebarText = () => {
  if (noticebarTextToUrl.value == "") {
    return;
  }
  YMPush("DOWNLOAD", "点击广播");
  statisticsPost(5);// 统计打点
  toLocationBrowser(noticebarTextToUrl.value);
  // window.location.href = noticebarTextToUrl.value;
};

const beforeChange = (e) => {
  console.log("beforeChange", e);
  if (e === 'private_chat') {
    if (isYk.value && web_pm_tips.value) {
      // Toast.fail("请先登录");
      nativeToLogin(router, true);
      return false;
    } else if (!checkSetNickname(user.value.fname, user.value.phone)) {
      return false;
    }
  }
  
  return true;
}

const onChange = (e) => {
  active.value = e;
  getMsglisth(500)
  if (e !== "chatroom") {
    showNewMsgAnimation.value = false;
  }
  if(e == 'private_chat'){
    // 延迟触发事件，确保 van-tabs 切换完成
    privateChatRedDot.value = false;
    markCurrentAutoAssistanceRead();
    nextTick(() => {
      EventBus.emit('changeToPrivate', 0); // 0表示直接点击标签切换
    });
  }
  if(e == 'chatzhubo'){
    active.value = 'private_chat';
    // 延迟触发事件，确保 van-tabs 切换完成
    nextTick(() => {
      EventBus.emit('changeToPrivate', 0); // 0表示直接点击主播私聊标签
    });
  }

  switch (e) {
    case 'saikuang':
      statisticsPost(10);
      return;
    case 'anchor':
      statisticsPost(11)
      return;
    case 'team':
      statisticsPost(12)
      return;
    case 'fenxi':
      statisticsPost(13)
      return;
    default:
      return;
  }
};
const copyclsaa = (copyclass, data) => {
  // copyclass元素的类名，data要复制的内容
  if (data != "" && data != null && data != undefined) {
    let clipboard = new Clipboard("." + copyclass, {
      text: () => {
        return data;
      },
    });
    clipboard.on("success", (e) => {
      if (copyclass == "copyLink") {
        YMPush("DOWNLOAD", "分享比赛");
        statisticsPost(4);
        Toast.success(t("tips.shareMatch"));
      } else {
        YMPush("DOWNLOAD", "copyid");
        // 统计打点
        statisticsPost(3);
        Toast.success(t("tips.copySuccess"));
      }
      // 释放内存
      clipboard.destroy();
    });
    clipboard.on("error", (e) => {
      console.log("浏览器不支持复制");
      // 释放内存
      clipboard.destroy();
    });
  } else {
    // 值为空
    if (copyclass == "copyID") {
      Toast.fail(t("me.zbnoid"));
    } else {
      Toast.fail(t("me.nrwk"));
    }
  }
};

const toMessagePage = () => {

   // 直接切换到主播私聊标签，显示会话列表
  active.value = 'private_chat';
  // 清除红点和动画
  privateChatRedDot.value = false;
  markCurrentAutoAssistanceRead();
  showOnMsg.value = false;
  redNum.value = 0;
   // 延迟触发事件，确保 van-tabs 切换完成
  nextTick(() => {
    // 发送事件，参数1表示从私信弹窗触发，需要显示会话列表
    EventBus.emit('changeToPrivate', 1);
  });
};

// const arterBg = require(`@/assets/${process.env.VUE_APP_NAME}/download.png`);
// const arterBtn = require(`@/assets/${process.env.VUE_APP_NAME}/download_btn.png`);
const offArterBtn = require("@/assets/images/guanbi.png");
const liveTimeDownloadBg = require(`@/assets/${process.env.VUE_APP_NAME}/liveTimeDownloadBg.png`);
const liveTimeDownloadBtn = require(`@/assets/${process.env.VUE_APP_NAME}/liveTimeDownloadBtn.png`);

const alertMatchShare = ref(false);
const getUrl = () => {
  let str = window.location.href;
  str = str.replace("ios", "h5");
  str = str.replace("android", "h5");
  // replace("-","/"
  str = str + "&replace=1";

  return str;
};

// 弹出红包广告 骗人玩意
const alertRB = ref(false);

const oppenRb = () => {
  const id = roomdata.value.free_id;
  sendImMsg({
    senduid: id,
    recvuid: Storage.get("uid"),
    msgtype: 14,
    content:
      playHbWeclome.value,
    // "老铁，欢迎回来，恭喜你获得18元新人红包，回复“体验金”即可获得领取教程"
  });
  Storage.set("showRb", "1111");
  alertRB.value = false;
  window.$apiNet.statisticsPost({ action_id: 26 });
  // window.open(playHbUrl.value)

  let chatkey;
  YMPush("CHAT", "私信主播");
  chatkey = IMUtils.createChatKey(id).toString();
  toMsgChat(router, id, chatkey);
};
const offRb = () => {
  Storage.set("showRb", "1111");
  alertRB.value = false;
};

//检查是不是app
const checkApp = () => {
  const { webclip } = route.query;
  if (!webclip && Platform.client == "h5") {
    return true;
  } else {
    return false;
  }
};

//有消息来了，就跑出来一个动画
const showNewMsgAnimation = ref(false);
const newMsgUser = ref({ url: "", name: "", uid: 0 });

const count = ref(0);
const showInterval = ref(false);
const adData = ref();
const toImg = (url: string) => {
  toLocationBrowser(url);
  // window.location.href = url
};
EventBus.on("roomPlayAd", (data: any) => {
  adData.value = data;
  count.value = parseInt(data.time);
  const dao = parseInt(data.dao);

  const time = setInterval(() => {
    count.value--;
    if (count.value < 1) {
      clearInterval(time);
      showInterval.value = false;
    }
    // console.log(dao);
    // console.log(count.value);
    // console.log(dao + 1 > count.value);

    if (dao + 1 > count.value) {
      showInterval.value = true;
    }
  }, 1000);
});

EventBus.on("msg_join_chatroom_nty", (data: any) => {

  if (Storage.get('uid') == data.base_data.uid) {
    if (match_type.value == '2') {
      // 篮球
      statisticsPost(19);
    } else if (match_type.value == '1') {
      // 足球
      statisticsPost(20);
    }
  }

});

//切换源的数据
const liveUrlList = ref([]);

const changeLineFn = (line) => {
  liveUrl.value = "";
  openLiveUrlBox.value = false;
  setTimeout(() => {
    // liveUrl.value = liveUrlList.value[Math.floor(Math.random() * liveUrlList.value.length)]
    liveUrl.value = line.url;
    console.log(liveUrl.value);
  }, 100);
  statisticsPost(6);// 统计打点
};

const openLiveUrlBox = ref(false);


const copyid = ref("");
const onCancel = () => {
  openLiveUrlBox.value = false;
};

//播放路径的原地址
const dataLiveUrl = ref('')
const toAZ = () => {
  if (Platform.client == "h5") {
    alertDown.value = true;
  } else {
    statisticsPost(7);// 统计打点
    // const str = liveUrl.value;
    const str = dataLiveUrl.value;
    toRemotePlay(str);
  }

};
const onclickPlay = () => {
  console.log("点击了");

}

const getHeaderHei = () => {
  const screen = document.documentElement;
  if (liveUrl.value == '' && match_data) {
    return 40 + Math.round(screen.clientWidth * 0.03);
  }
  return 40;
  // (liveUrl == '' && match_data) ? 'calc(40px + 3vw)' : '40px'

}

const getTopPx = () => {
  let hei = 40;
  if (noticebarText.value !== '') {
    hei += 20;
  }
  if (is_show_up68_copy_share.value) {
    hei += 35;
  }
  const screen = document.documentElement;
  return Math.round(screen.clientWidth * 0.56 + hei)
}

// const icon:any = reactive({
//   x: document.documentElement.clientWidth-65,
//   y: document.documentElement.clientHeight-190
// });
const screen = document.documentElement;
const tabsHeight = () => {
  let num = getTopPx();
  return screen.clientHeight - num;
};
//监听加入直播间成功
EventBus.on("msglisth", (data: any) => {
  getMsglisth(data)
});
const getMsglisth = (data) => {
  // let APPscorlltop=parseInt(data)-tabsH.value;
  // if(APPscorlltop<100){
  //   setTabsH.value=tabsH.value+220+'px';
  //   document.getElementById('app').scrollTop=1;
  //   document.getElementById('app').scrollTop=0;
  //   setTimeout(()=>{
  //     document.getElementById('app').scrollTop=10;
  //     // console.log('appscroll00',document.getElementById('app').scrollTop);
  //   },500);
  //   setTimeout(()=>{
  //     setTabsH.value='100%';
  //   },1000)
  // }else{
  //   setTabsH.value='100%';
  //   // console.log('msglisth11',data,APPscorlltop);
  //   document.getElementById('app').scrollTop=APPscorlltop+50;
  //   document.getElementById('app').scrollTop=50;
  //   setTimeout(()=>{
  //     document.getElementById('app').scrollTop=APPscorlltop+150;
  //     // console.log('appscroll2333',document.getElementById('app').scrollTop);
  //   },500)
  // }
}

const getLiveActivity = () => {
  window.$apiNet.get("app/encryptionLiveActivity", {}).then(({ code, data }) => {
    if (code == 200 && data && data.length) {
      activityDatas.value = data.sort((a, b) => { return b.id - a.id });
    }
  });
}


const onActivityClick = (item) => {
  console.log(item);

  
  if (item.jump_type && item.jump_type != "") {
    
    if (item.jump_type == 1) {
      let { jump_url } = item;
      if (jump_url.startsWith("/")) {
        nativeToNewWeb(router, jump_url);
      } else {
        toLocationBrowser(jump_url);
      }

    } else if (item.jump_type == 2) {
      nativeToNewWeb(router, `/player?id=${item.jump_room_id}&&matchType=${item.platform_type}`)
    } else if (item.jump_type == 3) {
      nativeToNewWeb(router, `/player?id=${item.jump_room_id}&&matchType=${item.platform_type}`)
    } else if (item.jump_type == 5) {
      const id = parseInt(item.type_id);
      let chatkey;
      chatkey = IMUtils.createChatKey(id).toString();
      toMsgChat(router, id, chatkey);
    } else if (item.jump_type == 6) {
      nativeToNewWeb(router, `/invitef?a=b`)
      window.$apiNet.statisticsPost({ action_id: 24 });
    } else if (item.jump_type == 7) {
      nativeToNewWeb(router, '/activity?a=1');
      window.$apiNet.statisticsPost({ action_id: 24 });
    }
  }
};

const statisticsPost = (action) => {
  window.$apiNet.statisticsPost({
    type_id: match_type.value,
    match_id: match_id.value,
    room_key: room_key.value,
    anchor_id: anchor_id.value,
    action_id: action + '',
  })
}


const toDingyue = (status) => {
  if (!match_data.value) {
    return;
  }
  let check_id = Storage.get("check_id");
  let check_type = Storage.get("check_type");

  let data = {
    check_type,
    check_id,
    match_id: match_data.value.id,
    match_type: match_data.value.type_id,
    status,
  }
  window.$apiNet.get("app/encryptionFollowMatch", data).then(({ code }) => {
    match_data.value.is_follow = status;
    if (status) {
      Toast({
        message: t('focuSucc'),
        position: 'top',
      })
      window.$apiNet.statisticsPost({ action_id: '8' });// 统计打点
    } else {
      Toast({
        message: t('cancelFocus'),
        position: 'top',
      })
    }
  })

}

// const checkAutoMsgToZB = () => {
//   let data = roomdata.value;
//   // console.log('automatically_send', data.set_data['automatically_send']);
//   // imChatModel
//   let autosend = data.set_data['automatically_send_data'];
//   console.log('checkAutoMsgToZB', autosend);

//   if (!autosend) {
//     return;
//   }
//   let list = [];
//   for (let i = 0; i < autosend.length; i++) {
//     const item = autosend[i];
//     let automsgtype = item['type'];
//     let content = item['content'];
//     let msgtype = automsgtype || 1;

//     if (msgtype == 10013) {
//       // 复制主播ID
//       content = JSON.parse(content);
//     }

//     if (autosend && autosend != '') {
//       list.push({
//         id: i + 1,
//         chatkey: zb_chatkey.value + '',
//         chatmsgno: i - autosend.length,
//         uid: data.free_id,
//         content: content,
//         headurl: data.portrait,
//         nickname: data.nickname,
//         phonenum: "",
//         time: Date.now() - (autosend.length - i) * 10000,
//         msgtype: msgtype,
//         clientkey: 'h5',
//         read: true,
//         send: true,
//         upLoadProgress: 100,
//       });
//     }
//   }

//   // list = list.reverse();

//   zb_autoMsg.value = JSON.stringify(list);
// }


const __returned__ = { t, ConfigpiniaStore, userStore, roomStore, toLogin, isLogin, isYk, user, changeIsjion, cleanMsgList, changeRoomPlayer, getConfig, roomMsgShield, matchShare, down68, copyidimg, shareImg, gift, th, changeLine, touping, playhz, plany_rb_bg, play_ktx, play_bt, app_name, dingyue_icon, yidingyue, active, configNoticebarText, configNoticebarTextTo, configCopyid, offChat, playHbTime, playHbPrice, playHbWeclome, is_has_history, is_show_host, is_has_intelligence, openAd, is_show_up68_copy_share, is_lb, live_jump_time, live_jump_interval, live_jump_info, live_jump_url, live_jump_closable, live_load_img, web_pm_tips, web_fullscreen_tips, replay_download_tips, is_has_player_stats, marqueeFontColor, marqueeColor, primaryColor, router, route, roomdata, ios, isZb, isNoUrl, hasUrl, coverData, liveStatus, hasData, liveUrl, roomHeat, videoType, videoUrl, noticebarText, noticebarTextToUrl, match_type, match_id, jionRoomSuccess, roomTitle, room_key, anchor_id, liveType, activityDatas, match_data, zb_chatkey, assistanceAutoMsg, videoPoster, videoAd, postInteval, privateChatRedDot, playerTimer, autoAssistanceTimer, autoAssistanceDelay, autoAssistanceSentPrefix, autoAssistanceCachePrefix, autoAssistanceReadPrefix, standalone, popstateBackRoute, postMsgToPlayer, onSixinClick, onChatZhuboClick, onclickSharel, liveToDownloadInterval, liveRoomTime, hasShowLiveToDownload, liveTimeDownload, checkLiveTime, checkLiveTick, replayDownloadTime, checkReplayDownload, liveTimeDonwApp, closeLiveTimeDownApp, closeAlertDown, checkStorageRb, tochatzb, showDownApp, checkWebclip, alertDown, setTime, onPostMessage, redNum, showOnMsg, getMsgList, getCurrentUid, getAutoAssistanceRoomKey, parseAutoAssistanceMessages, getAutoAssistanceMessages, getAutoAssistanceSentKey, getAutoAssistanceCacheKey, getAutoAssistanceReadKey, hasAutoAssistanceSent, hasAutoAssistanceRead, markAutoAssistanceRead, markCurrentAutoAssistanceRead, markAutoAssistanceSent, getAutoAssistanceCache, setAutoAssistanceCache, restoreAutoAssistanceMessages, normalizeAutoAssistanceContent, scheduleAutoAssistanceMessage, getAutoAssistanceChatMsgNo, showAutoAssistanceMessages, toJoinRoom, checkRoomType, checkNoType, checkMachthHost, matchIsMp4, qingyuan, getUrlMatch, getMatch, getData, getLiveInfo, backRouter, click68, clickNoticebarText, beforeChange, onChange, copyclsaa, toMessagePage, offArterBtn, liveTimeDownloadBg, liveTimeDownloadBtn, alertMatchShare, getUrl, alertRB, oppenRb, offRb, checkApp, showNewMsgAnimation, newMsgUser, count, showInterval, adData, toImg, liveUrlList, changeLineFn, openLiveUrlBox, copyid, onCancel, dataLiveUrl, toAZ, onclickPlay, getHeaderHei, getTopPx, screen, tabsHeight, getMsglisth, getLiveActivity, onActivityClick, statisticsPost, toDingyue, Platform, PlayChat, Cover, Anchor, AnchorTab, Live, TameBasketball, BasketBallFenxi, FootballFenxi, Zhishu, TeamFootball, Football, Basketball, back, football_bg, basketball_bg, Match, PlayerGroupChat, PlayerPrivateChat, formatDate, toDownloadApp }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})